import { Box, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import CutomerBookingTable from "../../features/manageCustomers/bookingTable";
import CustomPagination from "../../components/CustomPagination";
import { useLazyGetOfferBookingHistoryQuery } from "../../service/offer";
import { showError } from "../../constants/toasts";
import { BookingHistoryType } from "../../types/General";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

enum BOOKING_STATUS {
  UPCOMING = 0,
  PAST = 1,
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface BookingHistoryProps {
  hidePast?: boolean;
  offerId?: string;
  actionType: string;
}

function BookingHistory({
  hidePast = false,
  offerId,
  actionType,
}: BookingHistoryProps) {
  const [bookingHistory] = useLazyGetOfferBookingHistoryQuery();

  const [valueTabs, setValueTabs] = useState(0);
  const [bookings, setBookings] = useState<BookingHistoryType[]>([]);
  const [loading, setLoading] = useState(false);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const [page, setPage] = useState(1);
  const [totalBookings, setTotalBookings] = useState(0);

  const getBookingHistoryApi = async () => {
    try {
      setLoading(true);
      const response = await bookingHistory({
        offerId,
        status:
          valueTabs === BOOKING_STATUS.UPCOMING
            ? "upcoming"
            : valueTabs === BOOKING_STATUS.PAST
              ? "past"
              : "",
        page,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setBookings(response?.data?.items || []);
        setTotalBookings(response?.data?.totalCount || 0);
      } else {
        setLoading(false);
        setBookings([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getBookingHistoryApi();
  }, [valueTabs, page]);

  return (
    <>
      <div className="cards table_cards v2">
        <Box
          className="custom_tabs"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="booking tabs"
            className="custom_tabs_links"
          >
            {actionType === "expired" ? null : (
              <Tab label="Upcoming Bookings" {...a11yProps(0)} />
            )}

            {!hidePast && <Tab label="Past Bookings" {...a11yProps(1)} />}
          </Tabs>
          <p>{`Total Number of Bookings ( ${bookings?.length || "0"} )`}</p>
        </Box>

        <CustomTabPanel value={valueTabs} index={0}>
          <CutomerBookingTable bookingData={bookings} />
        </CustomTabPanel>

        {!hidePast && (
          <CustomTabPanel value={valueTabs} index={1}>
            <CutomerBookingTable isPast={true} bookingData={bookings} />
          </CustomTabPanel>
        )}
      </div>
      {bookings?.length ? (
        <CustomPagination
          currentPage={page - 1}
          totalPages={Math.ceil(totalBookings / 10)}
          count={totalBookings}
          pageSize={10}
          onPageChange={(page) => setPage(page + 1)}
        />
      ) : null}
    </>
  );
}

export default BookingHistory;
